import { on } from "@ngrx/store";
import { ApplicationStore } from "../../../application.state";
import { DataContractTypesActions } from "./contract-types.actions";

// **************************************************************************
// CONTRACT TYPES REDUCER
// **************************************************************************

const load = on(DataContractTypesActions.load, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        contractType: {
            ...state.data.contractType,
            contractTypesLoading: true,
        },
    },
}));

const loadSuccess = on(DataContractTypesActions.loadSuccess, (state: ApplicationStore, { contractTypes }) => ({
    ...state,
    data: {
        ...state.data,
        contractType: {
            ...state.data.contractType,
            contractTypes,
            contractTypesLoading: false,
        },
    },
}));

const loadFailure = on(DataContractTypesActions.loadFailure, (state: ApplicationStore, { error }) => ({
    ...state,
    data: {
        ...state.data,
        error,
        contractType: {
            ...state.data.contractType,
            contractTypesLoading: false,
        },
    },
}));

export const contractTypesReducer = [load, loadSuccess, loadFailure];
